import { Action } from '@ngrx/store';

export enum AssignmentsActionTypes {
  Load = '[Assignments] Load',
  LoadSuccess = '[Assignments] Load Success',
  LoadFail = '[Assignments] Load Fail',
  AssignUsers = '[Assignments] Assign Users',
  AssignUsersSuccess = '[Assignments] Assign Users Success',
  AssignUsersFail = '[Assignments] Assign Users Fail'
}

export class LoadAssignments implements Action {
  public readonly type = AssignmentsActionTypes.Load;

  constructor(public payload: string) {}
}

export class LoadAssignmentsSuccess implements Action {
  public readonly type = AssignmentsActionTypes.LoadSuccess;

  constructor(public payload: string[]) {}
}

export class LoadAssignmentsFail implements Action {
  public readonly type = AssignmentsActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export class AssignUsers implements Action {
  public readonly type = AssignmentsActionTypes.AssignUsers;

  constructor(public payload: { dealId: string; userIds: string[] }) {}
}

export class AssignUsersSuccess implements Action {
  public readonly type = AssignmentsActionTypes.AssignUsersSuccess;

  constructor(public payload: { dealId: string; userIds: string[] }) {}
}

export class AssignUsersFail implements Action {
  public readonly type = AssignmentsActionTypes.AssignUsersFail;

  constructor(public payload: string) {}
}

export type AssignmentsActionsUnion =
  | LoadAssignments
  | LoadAssignmentsSuccess
  | LoadAssignmentsFail
  | AssignUsers
  | AssignUsersSuccess
  | AssignUsersFail;
